import { render, staticRenderFns } from "./uiLogo.vue?vue&type=template&id=30833f18&scoped=true"
var script = {}
import style0 from "./uiLogo.vue?vue&type=style&index=0&id=30833f18&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30833f18",
  null
  
)

export default component.exports